const quickBetCardSelectors = {
    wrapper: ".js-ds-quick-bet-card-wrapper",
    card: ".js-ds-quick-bet-card",
    cardHeader: ".js-ds-quick-bet-card-header",
    cardListItem: ".js-ds-quick-bet-card-list-item",
};

const initQuickBetCardHeaders = (wrapper: HTMLElement) => {
    const onChangeCallback = () => {
        const cardHeaders: HTMLElement[] = [
            ...wrapper.querySelectorAll(quickBetCardSelectors.cardHeader),
        ] as HTMLElement[];

        cardHeaders.forEach((header) => {
            header.style.height = "";
        });

        const cardHeadersHeights: number[] = cardHeaders.map((header) => header.offsetHeight);
        const maxHeaderHeight: number = Math.max(...cardHeadersHeights);

        cardHeaders.forEach((header) => {
            header.style.height = `${maxHeaderHeight}px`;
        });
    };

    // Resize
    let timeout;
    window.onresize = () => {
        clearTimeout(timeout);
        timeout = setTimeout(onChangeCallback, 500);
    };

    // Observation
    const observerConfig: MutationObserverInit = {
        characterData: true,
        attributes: false,
        childList: true,
        subtree: true,
    };
    const observer = new MutationObserver(onChangeCallback);

    observer.observe(wrapper, observerConfig);

    // Init
    onChangeCallback();
};

const initQuickBetCardLists = (card: HTMLElement) => {
    const itemsCount: number = card.querySelectorAll(quickBetCardSelectors.cardListItem).length;

    if (itemsCount > 3) {
        card.classList.add("ds-quick-bet-card--wide");
    }
};

export { quickBetCardSelectors, initQuickBetCardHeaders, initQuickBetCardLists };
